<template>
  <div class="form-group" :class="{ 'has-error': hasError }">
    <label class="control-label" v-if="label">{{ label }}</label>
    <div>
      <date-picker
        :value="value"
        :config="datePickerOptions"
        @input="$emit('input', $event)"
        v-on="listeners"
      />
    </div>
    <span class="help-block" v-if="hasError">{{ errors[0] }}</span>
    <span class="text-warning" v-if="hasWarnings">{{ warnings[0] }}</span>
  </div>
</template>

<script>
import DatePicker from 'vue-bootstrap-datetimepicker';
import moment from 'moment';
import 'moment/locale/pt-br';

export default {
  props: {
    label: {
      type: String,
      default: '',
      required: true,
    },
    value: {
      type: [Object, String],
      default: () => {},
      required: true,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    warnings: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      datePickerOptions: {
        icons: {
          time: 'far fa-clock',
          date: 'far fa-calendar',
          up: 'fas fa-arrow-up',
          down: 'fas fa-arrow-down',
          previous: 'fas fa-chevron-left',
          next: 'fas fa-chevron-right',
          today: 'fas fa-calendar-check',
          clear: 'far fa-trash-alt',
        },
        tooltips: {
          clear: 'Limpar',
        },
        format: 'DD/MM/YYYY',
        locale: moment.locale('pt-BR'),
        showClear: true,
        showClose: false,
      },
    };
  },
  components: {
    DatePicker,
  },
  computed: {
    listeners() {
      const listeners = { ...this.$listeners };

      delete listeners.input;

      return listeners;
    },
    hasError() {
      return this.errors && this.errors.length;
    },
    hasWarnings() {
      return this.warnings && this.warnings.length;
    },
  },
};
</script>
